import React from 'react';

import { UncontrolledTable } from '~/components';
import usePatient from '~/utils/patient/hook';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import { MatchStatus } from '~/utils/const/identity';

const MedicalProblemList = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="medical-problem-list"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-problemlistdx',
        params: {
          sacwis_id: sacwisId,
          match_status_id: MatchStatus.Approved,
          'all-data': '1',
        },
      }}
      defaultSorted={[{ id: 'dateDt', desc: true }, { id: 'diagnosis' }]}
      columns={[
        {
          id: 'diagnosis',
          Header: 'Diagnosis',
          accessor: 'attributes.diagnosis',
        },
        {
          id: 'dateDt__>>',
          Header: 'Date',
          accessor: 'attributes.dateDt',
          cellType: 'date',
          Filter: d => <TableFilterDateRange {...d} />,
        },
        {
          id: 'provider',
          Header: 'Provider',
          accessor: 'attributes.provider',
        },
        {
          id: 'providerspecialty',
          Header: 'Provider Specialty',
          accessor: 'attributes.providerspecialty',
        },
        {
          id: 'sourceDescription',
          Header: 'Reporting Healthcare Institution',
          accessor: 'attributes.sourceDescription',
          Filter: d => <TableFilterIdentitySource {...d} />,
        },
      ]}
    />
  );
};

export default MedicalProblemList;
